// the key a source name's options are stored under: 'dictionary:key' -> 'key'
export function resolveDictionaryKey(sourceName: string) {
  if (sourceName.startsWith('dictionary')) {
    const [_, key] = sourceName.split(':');
    return key;
  }
  return sourceName;
}
